import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const patchReportDraftAsDeleted = async (projectId, reportDraftId) => {
  const apiPath = `report/project/${projectId}/report-draft/set-as-deleted`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PATCH',
    body: JSON.stringify({ reportDraftId }),
    data: { reportDraftId },
    headers: {
      'Content-Type': 'application/json',
    },
    service: 'execute-api',
    region: Config.AWS_REGION,
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
